export const fetchRoutes = (routes, currRole) => {
  return routes.filter((route) => {
    if ('profileStatus' in route) {
      if (route.profileStatus.length === 1 && route.profileStatus[0] === '*') {
        return route;
      } else {
        return route.profileStatus.includes(currRole) ? route : null;
      }
    } else return null;
  });
};
